import { Resources } from 'constants/resources';

import { MonitoringSettingsList } from 'pages/Monitoring/MonitoringSettings/MonitoringSettingsList/MonitoringSettingsList';
import { ResourceProps } from 'react-admin';

export const monitoringSettingsResource: ResourceProps = {
  name: Resources.MonitoringSettings,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: MonitoringSettingsList,
};
